import { ApolloQueryResult } from '@apollo/client';

import {
  EnrichmentAttributeTypeEnum,
  TargetAttributesQuery,
  useCustomObjectsQuery,
} from '../../../../generated/graphql';
import { useTargetAttributes } from '../useTargetAttributes';

export type CustomObjectsClient = {
  fetch: () => Promise<any>;
  fetchTargetAttributes: () => Promise<
    ApolloQueryResult<TargetAttributesQuery>
  >;
  loading: boolean;
  error?: any;
  data?: any;
};
export function useCustomObjects(): CustomObjectsClient {
  const { refetch, loading, error, data } = useCustomObjectsQuery();
  // TODO: Actually get the target type once it can handle custom objects
  const { refetch: fetchTargetAttributes } = useTargetAttributes({
    targetType: EnrichmentAttributeTypeEnum.SalesforceAccount,
  });

  return {
    fetch: refetch,
    fetchTargetAttributes,
    loading,
    error,
    data: data?.customObjects.nodes,
  };
}
